// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3IqGF","colMin":"styles_colMin__3yFj0"};